'use client'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { cn } from '@/utils/styles/cn'

type GoogleOauthBrowserCalloutProps = {
    flow: 'sign-in' | 'sign-up'
    className?: string
}

export function GoogleOauthBrowserCallout({ flow, className }: GoogleOauthBrowserCalloutProps) {
    const verb = flow === 'sign-in' ? 'log in' : 'sign up'

    return (
        <Alert variant="info" className={cn('rounded-lg px-3 py-2 text-xs leading-snug shadow-none', className)}>
            <AlertDescription className="text-xs leading-snug">
                <span className="font-medium">Google {verb}</span>
                {': '}
                Open Superscale on a browser like Safari, Chrome or Firefox — Google is often blocking {verb} with
                Google in in-app browsers (X, Instagram, etc.).{' '}
                <span className="opacity-90">Email {verb} below works everywhere.</span>
            </AlertDescription>
        </Alert>
    )
}
